import {
    Button,
    Divider,
    DownloadIcon,
    Flex,
    Text,
    TrashCanIcon,
} from "@fluentui/react-northstar";
import React from "react";
import styled from "styled-components";
import DialogConfirmationDelete from "../DialogDeleteConfirmation/DialogConfirmationDelete";

const BarTools = ({
    counterSelection = 0,
    disableDelete = false,
    isDownloading = false,
    isDeleting = false,
    onClickDownloadMultiple = () => null,
    onClickDeleteMultiple = () => null,
    onReset = () => null,
}) => {
    return (
        <Wrapper vAlign="center">
            <Flex vAlign="center" gap="gap.smaller">
                <TextSelection
                    content={counterSelection + " élément(s) sélectionné(s)"}
                />
                <Button
                    content="Réinitialiser"
                    text
                    onClick={onReset}
                    styles={{
                        color: "var(--color-primary)",
                        textDecoration: "underline",
                        fontSize: "14px",
                    }}
                />
            </Flex>
            <Flex>
                <Divider vertical styles={{ height: "20px" }} />
            </Flex>
            <Flex>
                <DialogConfirmationDelete
                    isDeleting={isDeleting}
                    disableDelete={disableDelete}
                    handleConfirmDeleteDocument={onClickDeleteMultiple}
                />
            </Flex>
            <Divider vertical styles={{ height: "20px" }} />
            <Flex>
                <Button
                    content="Télécharger"
                    icon={<DownloadIcon outline />}
                    flat
                    loading={isDownloading}
                    onClick={onClickDownloadMultiple}
                />
            </Flex>
        </Wrapper>
    );
};

export default BarTools;

const Wrapper = styled(Flex)`
    position: absolute;
    bottom: 80px;
    left: 0;
    right: 0px;
    margin: 0 auto;
    width: fit-content;
    padding: var(--spacing-xs-8, 8px) var(--spacing-l-24, 24px);
    align-items: center;
    gap: var(--spacing-m-16, 16px);

    border-radius: var(--radius-rounded-50, 50px);
    background: var(--Light-theme-Rest-Background-Default-Background, #fff);

    /* shadow-16 */
    box-shadow: 0px 1.2px 3.6px 0px rgba(0, 0, 0, 0.11),
        0px 6.4px 14.4px 0px rgba(0, 0, 0, 0.13);
`;

const TextSelection = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );

    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
`;
